// extracted by mini-css-extract-plugin
export default {"root":"cbkm5JtxetIBaitsZmrD","header":"hymqffs5GdRUFpo_TMah","list":"KBnH44RzotCwX9azx2Eo","placeHolderShimmer":"ZtMcjaTkKfGuCky_tL6A"};